import CpSideMenu from '@/components/common/sideMenu/CpSideMenu.vue'

// import MCP_CL_001 from '@/views/cp/MCP_CL_001.vue'
import MCP_CL_002 from '@/views/cp/MCP_CL_002.vue'
import MCP_CL_003 from '@/views/cp/MCP_CL_003.vue'
import MCP_CL_004 from '@/views/cp/MCP_CL_004.vue'

import MCP_CR_001 from '@/views/cp/MCP_CR_001.vue'
import MCP_CR_002 from '@/views/cp/MCP_CR_002.vue'
import MCP_CR_003 from '@/views/cp/MCP_CR_003.vue'
import MCP_CR_004 from '@/views/cp/MCP_CR_004.vue'
const companyRouter = [
    
    /* 화면명 : 회사 분류체계관리 ASIS  : MCP_CL_001  */
    // {
    //     path: "/cp/MCP_CL_001", 
    //     name : 'MCP_CL_001',
    //     component: () => import('@/views/cp/MCP_CL_001.vue'),
    //     meta :{
    //         title: '회사 분류체계 등록',
    //         IADepth: ['회사', '회사 분류기준 관리', '회사 분류체계 등록']
    //     }
    // },

    {
        path: "/cp/MCP_CL_002", 
        name : 'MCP_CL_002',
        components: {
            default : MCP_CL_002,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 분류체계 등록/수정',
            IADepth: ['회사', '회사 분류기준 관리', '회사 분류체계 등록/수정']
        }
    },
    
    {
        path: "/cp/MCP_CL_004", 
        name : 'MCP_CL_004',
        components: {
            default : MCP_CL_004,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 분류체계 조회',
            IADepth: ['회사', '회사 분류기준 관리', '회사 분류체계 조회']
        }
    },

    {
        path: "/cp/MCP_CL_003", 
        name : 'MCP_CL_003',
        components: {
            default : MCP_CL_003,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 분류체계 이력 조회',
            IADepth: ['회사', '회사 분류기준 관리', '회사 분류체계 이력 조회']
        }
    },

    {
        path: "/cp/MCP_CR_001", 
        name : 'MCP_CR_001',
        components: {
            default : MCP_CR_001,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 등록',
            IADepth: ['회사', '회사 등록관리', '회사 등록/수정']
        }
    },

    {
        path: "/cp/MCP_CR_002", 
        name : 'MCP_CR_002',
        components: {
            default : MCP_CR_002,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 조회',
            IADepth: ['회사', '회사 등록관리', '회사 조회']
        }
    },

    {
        path: "/cp/MCP_CR_003", 
        name : 'MCP_CR_003',
        components: {
            default : MCP_CR_003,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 수정',
            IADepth: ['회사', '회사 등록관리', '회사 등록/수정']
        }
    },

    {
        path: "/cp/MCP_CR_004", 
        name : 'MCP_CR_004',
        components: {
            default : MCP_CR_004,
            sideMenu : CpSideMenu
        },
        meta :{
            title: '회사 상세조회',
            IADepth: ['회사', '회사 등록관리', '회사 상세조회']
        }
    },

]

export {companyRouter}